/**
 * The origin written into canonicals, og:url, the sitemap and prerendered HTML.
 *
 * This was the bare literal `https://www.heyarchie.ai`, duplicated across FIVE
 * files: src/components/SEO/SEO.tsx, api/og.ts, api/article.ts,
 * api/sitemap.xml.ts and scripts/prerender.ts. heyarchie.com is now canonical
 * (Stuart, 2026-08-30) and www.heyarchie.ai 301s to it, so leaving the literal
 * would put a redirect hop on every canonical and sitemap entry — and five
 * copies means five chances to change four of them.
 *
 * Resolved from, in order:
 *   1. VITE_SITE_BASE_URL — inlined by Vite into the browser bundle
 *   2. SITE_BASE_URL      — plain node, for api/ and scripts/prerender.ts
 *   3. the old literal    — so an unset build behaves exactly as before
 *
 * `import.meta.env` does not exist under plain node, hence the guard: this
 * module is imported by the browser bundle AND by node scripts.
 */
function resolveBaseUrl(): string {
  const fromVite =
    typeof import.meta !== 'undefined' && (import.meta as { env?: Record<string, string | undefined> }).env
      ? (import.meta as { env?: Record<string, string | undefined> }).env?.VITE_SITE_BASE_URL
      : undefined;
  const fromNode = typeof process !== 'undefined' ? process.env?.SITE_BASE_URL : undefined;
  return (fromVite || fromNode || 'https://www.heyarchie.ai').replace(/\/+$/, '');
}

export const BASE_URL = resolveBaseUrl();
